export default "__VITE_ASSET__c6867e29__"